/* Where the generated door rows meet the shared fetch vocabulary.
 *
 * `@sx/api-client` owns *how* a door is spoken to (the fetch, the `ApiError` mapping, the
 * session cookie); `platform.gen.ts` — rendered from `sx_service.registry` — owns *which*
 * doors exist and what path each answers on. Binding them is one expression, and it
 * happens exactly once, here, so that every call site downstream says `doorClient("catalog")`
 * with `ConsoleDoorId` checked by the compiler rather than a string it hopes is a door.
 */

import { doorClients, type DoorClient, type DoorUploadClient } from "@sx/api-client";

import { CONSOLE_DOORS, type ConsoleDoorId } from "../platform.gen";
import { consoleFetch } from "./request-fetch";

const clients = doorClients<ConsoleDoorId>(
  Object.fromEntries(
    CONSOLE_DOORS.map((door) => [door.id, door.prefix]),
  ) as Record<ConsoleDoorId, string>,
  consoleFetch,
);

export const doorClient = (door: ConsoleDoorId): DoorClient =>
  clients.doorClient(door);

export const projectDoorClient = (
  door: ConsoleDoorId,
  projectId: string,
): DoorClient => clients.projectDoorClient(door, projectId);

export const doorUpload = (door: ConsoleDoorId): DoorUploadClient =>
  clients.doorUpload(door);

export const projectDoorUpload = (
  door: ConsoleDoorId,
  projectId: string,
): DoorUploadClient => clients.projectDoorUpload(door, projectId);

export const doorPrefix = clients.doorPrefix;
